

import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";
import inputbox from '@/components/ui/inputbox';
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'


import mainMenuTab from "@/components/mainMenuTab";
import cardbox from '@/components/ui/cardbox';
import navbar from '@/components/ui/navbar';
import loadmore from '@/components/ui/loadmore';
import dialogbox from '@/components/ui/dialogbox';
import switchbox from '@/components/ui/switchbox';
import buttonbox from '@/components/ui/buttonbox';

export default {
components: {ChinaAddressV4Data,mainMenuTab,cardbox,navbar,loadmore,dialogbox,inputbox,switchbox,buttonbox},
data(){
let default_logo = 'https://b2b-nwj.oss-cn-shanghai.aliyuncs.com/logo/default.png';
let default_banner = 'https://b2b-nwj.oss-cn-shanghai.aliyuncs.com/banner/default.png';
return {
addressData: ChinaAddressV4Data,
areaNames:[],
areaIds:[],
form:{
store_name: '',
region_id:"110101",
address: '',
tel :'',
logo: default_logo,
image_1: default_banner,
scope:'',
range:'',
min_cond_unit:'件',
min_cond_num:'',
}

}
},
methods:{
changeAddr(ids,names){
this.areaNames = names;
this.areaIds = ids;
console.log(ids);
},


hideAddr(state){

if(state && this.areaIds.length!=3){
this.$vux.toast.text("请至少滑动一次选择省市区，确定您是真实的操作");
}

if(state){

this.form.region_id = this.areaIds[2];
}
},


uploadLogo(files){
const file = files.target.files[0];
files.target.value = '';

if(!file){
return false;
}

if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
this.$vux.toast.text('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种','top');
return false
}

let formData = new FormData();
formData.append("logo", file);
const opts = {
url: api.myStoreLogoUpload,
data: formData,
processType: "file",
contentType: true,
}
common.query(opts).then(res=>{
this.$vux.toast.text("上传成功");
this.form.logo = res.data;
},res=>{
this.$vux.toast.text(res.message,'top');
})

},
uploadBanner(files){
const file = files.target.files[0];
files.target.value = '';

if(!file){
return false;
}

if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
this.$vux.toast.text('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种','top');
return false
}

let formData = new FormData();
formData.append("banner", file);
const opts = {
url: api.myStoreBannerUpload,
data: formData,
processType: "file",
contentType: true,
}
common.query(opts).then(res=>{
this.$vux.toast.text("上传成功");
this.form.image_1 = res.data;
},res=>{
this.$vux.toast.text(res.message,'top');
})

},

request(){
if(this.form.store_name.length < 1){
this.$vux.toast.text('网店店名不能为空');
return false;
}
if(this.form.tel.length < 1){
this.$vux.toast.text('店主手机号不能为空');
return false;
}
if(this.form.range.length < 1){
this.$vux.toast.text('配送范围不能为空');
return false;
}
if(this.form.scope.length < 1){
this.$vux.toast.text('经营范围不能为空');
return false;
}


const opts = {
url: api.myStoreRequest,
data: this.form,
type: 'post'
}
common.query(opts).then(res=>{


this.$vux.toast.text("申请成功");
},res=>{
this.$vux.toast.text(res.message);
});
},

queryMyStore(){

const opts = {
url: api.myStore,
data: {},
type: 'get'
}
common.query(opts).then(res=>{


if('state' in res.data) {
if(res.data.state + '' === '0') {
this.$vux.toast.text('你的店铺还在审核中，请耐心等待.');
this.$router.push("/member/my");
} else {
this.$router.push("/store?storeId=" + res.data.store_id);
}
}
},res=>{

});
},
},
mounted(){
this.queryMyStore();
},
}




// WEBPACK FOOTER //
// ./src/views/member/newStore.vue